import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faMapLocationDot } from '@fortawesome/free-solid-svg-icons';

import './place.css';

const Place = () => {
  return (
    <div className="giswnauce__place">
        <div className="giswnauce__place-container">
            <span className="anchor-place" id="giswnauce_place"></span>
            <div className="place-container_header">
                <p><FontAwesomeIcon icon={faMapLocationDot} /></p><h1>Miejsce</h1>
            </div>
            <div className="place-container_subheader">
                <h2>Miejsce konferencji</h2>
            </div>
            <div className="place-container_description">
                <h3> Hotel Omega<br/> 
                ul. Sielska 4a<br/>
                10-802 Olsztyn</h3>
                <iframe title="CI TASK on google maps" src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d2182.9405144195!2d20.4431294763435!3d53.7726797427392!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x46e27f1f42d96803%3A0x3a87a126ba979550!2sHotel%20Omega!5e1!3m2!1spl!2spl!4v1778741943659!5m2!1spl!2spl" allowFullScreen="" loading="lazy" referrerPolicy="no-referrer-when-downgrade"></iframe>
            </div>
            <div className="place-container_content">
                <p>
                    Tegoroczne wydarzenie odbędzie się w Hotelu Omega w Olsztynie – urokliwym miejscu o wysokim standardzie, położonym bezpośrednio nad jeziorem Ukiel. Obiekt zapewnia bardzo dobre warunki zarówno do organizacji sesji naukowych, warsztatów, jak i integracji uczestników konferencji.
                </p>
                <p>
                    Na hasło „<b>GIS w Nauce</b>” uczestnicy mogą skorzystać ze specjalnych rabatów na noclegi:
                </p>
                <ul>
                    <li><b>40 zł rabatu</b> na pokój 1-osobowy,</li>
                    <li><b>60 zł rabatu</b> na pokój 2-osobowy.</li>
                </ul>
                <p>
                    Oferta obejmuje możliwość rezerwacji <b>do dwóch dób hotelowych</b> w preferencyjnej cenie. W cenie noclegu zapewnione są <b>śniadanie oraz bezpłatny parking na terenie hotelu</b>.
                </p>
                <p><b>Oferta na zniżkę limitowana.</b></p>
            </div>
        </div> 
    </div>
  )
}

export default Place